import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    payload: {}, //before add in cart
    products: [],
    loading: false,
    cartOpen: false,
  },
  actions,
  getters,
  mutations,
};